import { Typography, Tooltip, LazyImage } from '@frontend/design_system'
import { useNavigate } from 'react-router-dom'
import infoIcon from 'assets/icons/whiteMaster/whiteMaster_info_12x12.webp'
import { PendingCardProps } from './types'
import styles from './styles.module.scss'
import { joinClasses } from 'utils/joinClasses'
import { StatusBadge } from 'ui/atoms/StatusBadge'
import { REGISTRATION_STATUSES } from 'api/auth/constants'
import { StatusBadgeProps } from 'ui/atoms/StatusBadge/types'
import {
  PENDING_CARD_TOOLTIP,
  STATUS_BADGE_STATUSES,
} from 'texts/pendingForApproval'
import { statusBadge } from './constants'

const classNames = {
  [REGISTRATION_STATUSES.REVIEW]: styles.review,
  [REGISTRATION_STATUSES.REQUESTED]: styles.requested,
  [REGISTRATION_STATUSES.APPROVED]: styles.approved,
  [REGISTRATION_STATUSES.INCOMPLETE]: styles.incomplete,
}

export const PendingCard = ({
  Icon,
  title,
  description,
  status,
  path,
  disabled = false,
}: PendingCardProps) => {
  const navigate = useNavigate()

  const isShouldRenderStatusBadge =
    [
      REGISTRATION_STATUSES.REVIEW,
      REGISTRATION_STATUSES.REQUESTED,
      REGISTRATION_STATUSES.APPROVED,
    ].includes(status) && !disabled

  const handleClick = () => {
    if (path && !disabled) {
      navigate(path)
    }
  }

  return (
    <div
      className={joinClasses(styles.container, classNames[status], [
        styles.disabled,
        disabled,
      ])}
      onClick={handleClick}
      data-testid="pending-card"
    >
      {Icon}
      <Typography
        name="body1WBold"
        className={styles.title}
        color={disabled ? 'grey200' : 'blackMaster'}
      >
        {title}
      </Typography>
      {isShouldRenderStatusBadge && (
        <StatusBadge
          typographyName="caption2WBold"
          label={
            <div className={styles['status-badge']}>
              {STATUS_BADGE_STATUSES[status]}
              {status === REGISTRATION_STATUSES.REQUESTED && (
                <Tooltip
                  size="primary"
                  popupContent={PENDING_CARD_TOOLTIP}
                  placement="bottom"
                  alignSelf="center"
                >
                  <LazyImage src={infoIcon} width={12} height={12} />
                </Tooltip>
              )}
            </div>
          }
          status={statusBadge[status] as StatusBadgeProps['status']}
        />
      )}
      {(disabled || status === REGISTRATION_STATUSES.INCOMPLETE) && (
        <Typography
          name="body2WRegular"
          color={!disabled ? 'blackMaster' : 'grey200'}
        >
          {description}
        </Typography>
      )}
    </div>
  )
}
